import React from 'react';
import { MissionIcon } from "assets/icons";
import UseContext from "hooks/useContext";
import SidebarUnitMobile from "components/sidebar/components/SidebarUnitMobile";

const MissionPeriodML = ({ pathname }) => {
    const { language } = UseContext();
    const isActive = pathname.includes("missions");
    
    return (
        <SidebarUnitMobile routeName={"Missions"} routeSidebar={"/missions"}>
            <div className="flex flex-col justify-center items-center">
                <span className='shrink-0'>
                    <MissionIcon wh={28} color={isActive ? '#FF9600' : '#6B7280'} />
                </span>
                <span
                    className={`text-[9px] font-medium whitespace-normal text-center ${
                        isActive && "!text-[#FF9600]"
                    }`}
                >
                    {language.getValue('sidebar.missions', 'Missions')}
                </span>
            </div>
        </SidebarUnitMobile>
    );
};

export default MissionPeriodML;
